import axios, {
  AxiosInstance,
  AxiosResponse,
  AxiosError,
  InternalAxiosRequestConfig,
} from 'axios';
import { v4 as uuidv4 } from 'uuid';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001';

let isLoggingOut = false;

const Axios: AxiosInstance = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
    'dash-client-type': 'web',
    'X-Channel': 'ATTENDANCE',
  },
});

export const setBearerTokenFromLocalStorage = () => {
  if (typeof window !== 'undefined') {
    // Prioritize backend token for this web, fallback to Firebase token for compatibility
    const token =
      localStorage.getItem('token') || localStorage.getItem('accessToken');
    if (token) {
      Axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
      Axios.defaults.headers.common['dash-client-type'] = 'web';
    }
  }
};

Axios.interceptors.request.use(
  (config: InternalAxiosRequestConfig) => {
    const idempotencyKey = uuidv4();
    const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    config.headers['X-Idempotency-Key'] = idempotencyKey;
    config.headers['X-Client-Time-Zone'] = timeZone;

    setBearerTokenFromLocalStorage();

    return config;
  },
  (error: AxiosError) => {
    return Promise.reject(error);
  }
);

Axios.interceptors.response.use(
  (response: AxiosResponse) => response,
  async (error: AxiosError) => {
    if (error.response && error.response.status === 401) {
      if (!isLoggingOut) {
        isLoggingOut = true;
        localStorage.clear();
        window.location.href = '/signin';
        isLoggingOut = false;
      }
    }
    return Promise.reject(error);
  }
);

setBearerTokenFromLocalStorage();

export default Axios;
